import moment from 'moment';
import { isValidNumber } from '@gp/utils/common';
import {
  MAX_DIFF_MONTHS,
  FIELD_MAP,
  FIXED_FIELD_SERIES_ITEM_COLOR_ARR,
  FIXED_FIELD_SERIES_ITEM_COLOR_MAP,
} from './constants';

export const checkDateRangeDiff = (
  startDate: moment.Moment,
  endDate: moment.Moment,
  diff = MAX_DIFF_MONTHS,
  diffUnit = 'months',
): boolean => {
  const startDateTemp = moment.isMoment(startDate) ? startDate : moment(startDate);
  const endDateTemp = moment.isMoment(endDate) ? endDate : moment(endDate);
  // @ts-ignore
  return endDateTemp.diff(startDateTemp, diffUnit) <= diff;
};

// 处理Headcounts模块、Headcount Cost模块、5Y Headcounts模块 接口返回数据
export const handleDatas = (responseRes: any, module?: string): any => {
  const data = responseRes?.data?.data?.list || responseRes?.data?.data;
  if (!Array.isArray(data) || !data?.length) return null;
  try {
    const metrics: string[] = [];
    const dataList: { [key: string]: string }[] = [];
    for (let index = 0; index < data?.length; index++) {
      const item = data?.[index];
      const metricList: { [key: string]: string } = {};
      let valueType = '';
      let total = '';
      for (let i = 0; i < item?.metrics_info?.length; i++) {
        const t: {
          name: string;
          value: string;
          actual_or_forecast: string; // 1: actual 2: forecast
        } = item?.metrics_info?.[i];
        if (['1', '2']?.includes(t?.actual_or_forecast) && !valueType) {
          valueType = t?.actual_or_forecast == '1' ? 'actual' : 'forecast';
        }
        const name = module ? FIELD_MAP?.[module]?.[t?.name?.toLowerCase()?.trim() || ''] || t?.name : t?.name;
        metricList[name] = t?.value;
        if (isValidNumber(t?.value)) {
          total = String(Number(total) + Number(t?.value));
        }
        metrics.includes(name) || metrics.push(name);
      }
      dataList.push({
        valueType,
        date: item.date,
        total,
        ...metricList,
      });
    }
    // 把Others固定排在最后
    if (metrics.includes('Others')) {
      const index = metrics.indexOf('Others');
      metrics.splice(index, 1);
      metrics.push('Others');
    }

    return {
      isSuccessReq: responseRes?.status === 200 && responseRes?.data?.code === 200,
      metrics,
      dataList,
    };
  } catch (error) {
    console.error(error);
    return null;
  }
};

// R&D、Publisher&Marketing、Others类别颜色固定
export const getFixedFieldColor = (fieldName: string): string => {
  if (!fieldName || typeof fieldName !== 'string') return '';
  let fieldColor = '';
  FIXED_FIELD_SERIES_ITEM_COLOR_ARR.forEach((item: string, index: number) => {
    if (fieldName?.toLowerCase()?.indexOf(item) !== -1) {
      fieldColor = FIXED_FIELD_SERIES_ITEM_COLOR_MAP?.[item] || '';
    }
  });

  return fieldColor;
};
